"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionUpdater = void 0;
const _1 = require(".");
const constants_1 = require("./constants");
const sessionUpdater = ({ setCookie, setAuthenticated, setUser }) => (session) => {
    const { refreshTokenCookie, sessionTokenCookie } = _1.globalAuthContext.state;
    if (session) {
        const { jwt, refreshToken, user } = session;
        Boolean(refreshToken) && setCookie(refreshTokenCookie, refreshToken, constants_1.COOKIE_OPTIONS); // getSession query always returns null for refreshToken
        setCookie(sessionTokenCookie, jwt, constants_1.COOKIE_OPTIONS);
        setAuthenticated(Boolean(jwt));
        setUser(user);
        // memcache user to reduce calls to auth service
        _1.globalAuthContext.set({ user });
    }
};
exports.sessionUpdater = sessionUpdater;
